function setupHost() {
  if (__DEV__) return "churchcenter.test"
  if (import.meta.env.VITE_ACTIVE_ENV === "staging")
    return "staging.churchcenter.com"
  return "churchcenter.com"
}

export const SETUP_URL = `https://${setupHost()}/setup`
